<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <router-link :to="'/Consumable/Use'">
          <el-button type="primary" size="mini">物品领用申请</el-button>
        </router-link>
      </div>

      <label class="label-name">所属公司：</label>
      <el-select size="mini" :disabled="noSelectOrganization" class="organization-select" v-model="form.depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>

      <label style="margin-left:10px;" class="label-name">搜索：</label>
      <el-input style="display:inline-block;width:300px;" v-model="filterKey" size="small"
        placeholder="你可以搜索物品领用申请人/所属工程/客户名称"></el-input>

    </div>

    <div class="tab-radio-tool">
      <el-radio-group size="mini" v-model="form.type">
        <el-radio-button label="0">申请中/未出库物品</el-radio-button>
        <el-radio-button label="1">已出库物品</el-radio-button>
      </el-radio-group>
    </div>

    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column label="领用物品简报">
        <template slot-scope="scope">
          {{ getUseConsumables(scope.row.consumables) }}
        </template>
      </el-table-column>
      <el-table-column label="物品领用申请人" width="160">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>
      <el-table-column label="申请时间" width="140">
        <template slot-scope="scope">
          <span v-html="getDateByTime(scope.row.flow.createTime)"></span>
        </template>
      </el-table-column>
      <el-table-column v-if="form.type==0" :key="Math.random()" label="审批状态" width="100">
        <template slot-scope="scope">
          <approval-status :flow="scope.row.flow" :approvals="scope.row.flow.approvals" :status="scope.row.flow.status"></approval-status>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="145">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="projectDetail(scope.row)" type="primary">查看</el-button>

          <span v-if="scope.row.flow.creator.id==userData.id">
            <!-- 取消审批 -->
            <cancel-flow :successPlus="true" :flow="scope.row.flow" @getLists='getLists'></cancel-flow>
          </span>

          <span v-if="scope.row.flow.status == '审批通过' && backRole('YH_9')">
            <el-button size="mini" v-if="scope.row.type==0" @click="materialOut(scope.row)" type="success">出库
            </el-button>
            <!-- <el-button size="mini" v-if="scope.row.type==1 && !scope.row.backId" @click="materialBack(scope.row)" type="warning">退库</el-button> -->
          </span>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <project-info></project-info>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import CancelFlow from '@/components/CancelFlow'
  import projectInfo from '@/page/user/projectInfo'
  import approvalType from '@/Mixins/approvalType'

  import UserInfo from '@/components/UserInfo'
  import Role from '@/Mixins/role'
  import ApprovalStatus from '@/components/ApprovalStatus'

  export default {
    components: {
      UserInfo,
      projectInfo,
      ApprovalStatus,
      CancelFlow,
    },
    mixins: [approvalType, Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
        fManagerStorage: state => state.storage.fManagerStorage,
      })
    },
    data() {
      return {
        // 是否可切换公司
        noSelectOrganization: false,
        houseList: "",

        organizationListData: [],
        addMeetingRoomStatus: false,

        form: {
          depId: '',
          type: 0
        },
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
        // filter
        filterKey: "",
      }
    },
    created() {
      this.organizationListData = this.organization[0].childDepts
      this.form.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.form.depId == "7") {
        this.noSelectOrganization = false
      }

      this.getLists()
    },
    mounted() {},
    methods: {
      getUseConsumables(item) {
        return item.map(item => item.name).join(" , ")
      },
      // 物品出库
      materialOut(row) {
        ajax.post('/consumable/out', {
          applyId: row.id
        }, (res) => {
          this.$message.success("物品出库成功")
          this.getLists()
        })
      },
      // 显示审批表详情
      projectDetail(row) {
        let _projectTable = {
          status: true,
          applyId: row.flow.applyId,
          // 易耗品领用：63
          tableType: '63',
        }
        this.$store.commit('set_projectTable', _projectTable)
      },
      getDateByTime(time) {
        // return time
        return window.util.getFormatDate(time, true)
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        // console.log(this.filterKey)
        if (this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _item = this.listData[i]

            if (_item.flow.creator.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1) {
              this.filterData.push(_item)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        this.filterKey = ""
        this.loading = true
        let _url = '/consumable/use/list'

        ajax.get(_url, this.form, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      'form.depId'() {
        this.getLists()
      },
      'form.type'() {
        this.getLists()
      },
      filterKey() {
        this.getFilterData()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/consumable/UseList.vue